import { lazy } from "react";
import { Navigate, RouteObject } from "react-router-dom";
import CadastrarCooperativa from "../screens/Login/components/CadastrarCooperativa";
import VerificarAssinatura from "../screens/VerificarAssinatura";
import FormCotacaoFornecedor from "../screens/Estoque/components/MICompras/FormCotacaoFornecedor";

const Login = lazy(() => import("../screens/Login"));

export default function publicRoutes(): Array<RouteObject> {
  return [
    { path: "/login", element: <Login /> },
    { path: "/cadastro-cooperativa", element: <CadastrarCooperativa/>},
    { path: "/verificar", element: <VerificarAssinatura/>},
    { path: "*", element: <Navigate to="/login" replace /> },
    { path: "/cotacao-fornecedor/:cotacaoId", element: <FormCotacaoFornecedor/>},
  ];
}